const PREFIX = 'yi-tour'

function key(userId: string, suffix: string): string {
  return `${PREFIX}-${userId}-${suffix}`
}

export function isTourCompleted(userId: string, tourName: string): boolean {
  return localStorage.getItem(key(userId, tourName)) !== null
}

export function markTourCompleted(userId: string, tourName: string): void {
  localStorage.setItem(key(userId, tourName), new Date().toISOString())
}

export function hasSeenFirstLoginPrompt(userId: string): boolean {
  return localStorage.getItem(key(userId, 'first-login-prompt')) === 'true'
}

export function markFirstLoginPromptSeen(userId: string): void {
  localStorage.setItem(key(userId, 'first-login-prompt'), 'true')
}
